// modules
import React from 'react'

// components
import Icon from 'src/components/Icon'

const OfflineError = () => (
  <div className="unexpected-error">
    <Icon className="icon" name="exclamation-circle" />

    <h1>Oops! We are unable to connect to the internet</h1>

    <span>
      Please{' '}
      <a
        href="#"
        onClick={(e) => {
          e.preventDefault()
          window.location.reload(true)
        }}>
        click here
      </a>{' '}
      to try again
    </span>
  </div>
)

export default OfflineError
